/**
 * Membres de l’équipe affichés dans la section « Derrière le journal » de la page d’accueil
 * (src/home/sections/Equipe.js).
 *
 * Règle : uniquement des liens réels, pérennes et vérifiés (profil LinkedIn, dépôt GitHub),
 * à leur adresse canonique ; pas d’ancre « # », pas d’URL d’image signée.
 * `label` sert à nommer le lien pour les lecteurs d’écran.
 * `imageSrc` est facultatif : sans photo, un monogramme est affiché.
 */
import { ReactComponent as LinkedinIcon } from "images/linkedin-icon.svg";
import { ReactComponent as GithubIcon } from "images/github-icon.svg";

export const membres = [
  {
    name: "Jimmy Inthalangsy",
    position: "Fondateur du journal IA Besançon · Développeur IA",
    imageSrc: null,
    links: [
      { label: "LinkedIn", url: "https://www.linkedin.com/in/jimmy-inthalangsy-37a4b229a", icon: LinkedinIcon },
      { label: "GitHub", url: "https://github.com/jimmindev", icon: GithubIcon },
    ],
  },
];

export default membres;
